import React, { useState, useEffect, memo } from 'react'
import { tireList } from '../../../../../functions/stateList'
import CarModalInput from '../../../../inputs/CarModalInput'

function TireServiceData({ activeFilter, services, setServices }) {
  const [inputs, setInputs] = useState({})
  const [km, setKm] = useState(5000)

  useEffect(() => {
    let currentList = services.filter((service) => service?.service_category === activeFilter)
    let queryParams = {}
    for (let item of currentList) {
      queryParams[item?.type] = item?.description
    }
    setInputs({
      ...inputs,
      ...queryParams,
    })
  }, [])

  const inputHandler = (e) => {
    services.push({
      type: e.target.name,
      description: e.target.value,
      service_category: activeFilter,
      useful_km: km,
    })
    const key = 'type'
    const unique = [...new Map(services.map((item) => [item[key], item])).values()]
    setServices([...unique])
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    })
  }
  return (
    <>
      {tireList?.length > 0 &&
        tireList.map((item) => (
          <div key={item.id} className={'flex flex-col mb-12'}>
            <h3 className={'text-blue text-lg font-medium mb-4 dark:text-amber-100'}>
              {item.label}
            </h3>
            <label
              className={
                'text-normal font-md flex item-center mb-4 cursor-pointer dark:text-gray-200'
              }
              htmlFor={`changed${item.id}`}
            >
              <input
                onChange={inputHandler}
                value={'changed'}
                checked={inputs?.[item.label] === 'changed'}
                className={'ml-2 w-5 h-5'}
                type="radio"
                name={item.label}
                id={`changed${item.id}`}
              />
              انجام شد
            </label>

            <label
              className={'text-normal font-md flex item-center cursor-pointer dark:text-gray-200'}
              htmlFor={`change_next_visit${item.id}`}
            >
              <input
                onChange={inputHandler}
                value={'change_next_visit'}
                checked={inputs?.[item.label] === 'change_next_visit'}
                className={'ml-2 w-5 h-5'}
                type="radio"
                name={item.label}
                id={`change_next_visit${item.id}`}
              />
              مراجعه بعد
            </label>
          </div>
        ))}

      {(inputs?.['جا اندازی لاستیک نو'] === 'changed' ||
        inputs?.['بالانس لاستیک'] === 'changed' ||
        inputs?.['جا به جایی لاستیک های عقب'] === 'changed') && (
        <div className={'w-full flex flex-col '}>
          <div className="max-w-[300px]">
            <CarModalInput
              maxLength={9}
              title={'مقدار پیمایش لاستیک ها'}
              type={'number'}
              name={'km'}
              value={km}
              inputHandler={(e) => setKm(parseInt(e.target.value))}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default memo(TireServiceData)
